"use client";

import { createContext, useContext } from "react";
import type { OrganizationOnboardingStatusResponse } from "@/@sdk/user-management/user-management.controller-models";

export const EXPRESS_ONBOARDING_RESUME_WORKSPACE_EVENT =
  "express-onboarding:resume-workspace";

export type ExpressOnboardingContextValue = {
  workspaceStatus: OrganizationOnboardingStatusResponse | null;
  shouldShowContinueBanner: boolean;
  canResumeWorkspaceWizard: boolean;
  resumeWorkspaceWizard: () => Promise<void>;
};

export const ExpressOnboardingContext =
  createContext<ExpressOnboardingContextValue | null>(null);

export function useExpressOnboarding() {
  const context = useContext(ExpressOnboardingContext);
  if (!context) {
    throw new Error(
      "useExpressOnboarding must be used within ExpressOnboardingProvider"
    );
  }
  return context;
}

export function useOptionalExpressOnboarding() {
  return useContext(ExpressOnboardingContext);
}
